<template>
  <div class="cleaner-layout">
    <div class="cleaner-layout__content">
      <router-view />
    </div>
    <van-tabbar v-model="active" fixed safe-area-inset-bottom @change="onTabChange">
      <van-tabbar-item icon="home-o">首页</van-tabbar-item>
      <van-tabbar-item icon="todo-list-o">任务单</van-tabbar-item>
      <van-tabbar-item icon="calendar-o" :badge="scheduleBadge">今日日程</van-tabbar-item>
      <van-tabbar-item icon="user-o">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import { daysOrderList } from '@/api/lxz/cleaner'

const TAB_PATHS = ['/cleanerPage/home', '/cleanerPage/orders', '/cleanerPage/schedule', '/cleanerPage/mine']

const pad2 = (n) => String(n).padStart(2, '0')
const getTodayKey = () => {
  const d = new Date()
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`
}

export default {
  name: 'CleanerLayout',
  data() {
    return {
      active: 0,
      scheduleCount: 0,
      scheduleLoading: false
    }
  },
  computed: {
    scheduleBadge() {
      if (!this.scheduleCount) return null
      if (this.scheduleCount > 99) return '99+'
      return String(this.scheduleCount)
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        const idx = TAB_PATHS.indexOf(route.path)
        this.active = idx === -1 ? 0 : idx
        if (route && route.path && route.path.indexOf('/cleanerPage/') === 0) this.refreshScheduleCount()
      }
    }
  },
  mounted() {
    this.refreshScheduleCount()
    document.addEventListener('visibilitychange', this.onVisibilityChange)
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.onVisibilityChange)
  },
  methods: {
    onVisibilityChange() {
      if (document.hidden) return
      this.refreshScheduleCount()
    },
    async refreshScheduleCount() {
      if (this.scheduleLoading) return
      this.scheduleLoading = true
      try {
        const day = getTodayKey()
        const res = await daysOrderList({ day, page: 1 })
        if (res && res.status === 200) {
          const list = (res.data && (res.data.list || res.data.data || res.data)) || {}
          const total = Number(list.total || list.count || list.total_count || 0)
          const raw = Array.isArray(list.data) ? list.data : Array.isArray(list) ? list : []
          const count = total > 0 ? total : raw.length
          this.scheduleCount = Number.isFinite(count) && count > 0 ? count : 0
        } else {
          this.scheduleCount = 0
        }
      } catch (e) {
        this.scheduleCount = 0
      } finally {
        this.scheduleLoading = false
      }
    },
    onTabChange(index) {
      const path = TAB_PATHS[index] || TAB_PATHS[0]
      if (this.$route.path !== path) this.$router.replace(path)
    }
  }
}
</script>

<style scoped>
.cleaner-layout {
  min-height: 100%;
}
.cleaner-layout__content {
  min-height: 100%;
  padding-bottom: 62px;
}
</style>
